/**
 * @file paddle hub 列表页常量
 * @author FengGuang(fengguang01@baidu.com)
 */

import getSortParams from '../../utils/get-sort-params';
import {IPaddleHubMenu} from './type.d';

// 置顶的热门模型分类
export const PADDLE_MENU_HOT: IPaddleHubMenu = (() => {
    const search = {
        filter: 'hot',
        value: '1'
    };

    return {
        key: getSortParams(search),
        search,
        name: {
            en: 'hot model',
            chn: '热门模型'
        },
        chs: []
    };
})();

// 置顶的开发者模型分类
export const PADDLE_HUB_MENU_DEV: IPaddleHubMenu = (() => {
    const search = {
        filter: 'contributor',
        exclude: 'Baidu'
    };
    return {
        key: getSortParams(search),
        search,
        name: {
            en: 'developer model',
            chn: '开发者贡献'
        },
        chs: []
    };
})();
// 置顶的模型分类，由前端写死而不是后端返回
export const PADDLE_HUB_MENU_TOP: IPaddleHubMenu[] = [
    PADDLE_MENU_HOT,
    PADDLE_HUB_MENU_DEV
];

export const DEFAULT_PADDLE_MENU_FILTER = 'en_category';
